module.exports = __webpack_public_path__ + "static/media/ss-returns-logo.736638bc.svg";